import { Percentage } from '@sparkdotfi/common-universal'

import { SavingsConverter } from '@/features/savings/logic/savings-converters/types'

export interface DetermineApyImprovementParams {
  savingsUsdsConverter: SavingsConverter | null
  savingsDaiConverter: SavingsConverter | null
}

export function determineApyImprovement({
  savingsUsdsConverter,
  savingsDaiConverter,
}: DetermineApyImprovementParams): Percentage | undefined {
  if (!savingsUsdsConverter || !savingsDaiConverter) {
    return undefined
  }
  const apyDifference = savingsUsdsConverter.apy.minus(savingsDaiConverter.apy)
  return apyDifference.gt(Percentage(0)) ? apyDifference : undefined
}
